export default __webpack_public_path__ + "static/media/subscription1.7749c733.png";